export var OrderNotifyStatusChangeEnum;
(function (OrderNotifyStatusChangeEnum) {
    OrderNotifyStatusChangeEnum["ORDER_STATUS_UPDATE_NEXT"] = "ORDER_STATUS_UPDATE_NEXT";
    OrderNotifyStatusChangeEnum["ORDER_STATUS_UPDATE_ALL"] = "ORDER_STATUS_UPDATE_ALL";
    OrderNotifyStatusChangeEnum["DELAYED_ORDER_REMINDER"] = "DELAYED_ORDER_REMINDER";
    OrderNotifyStatusChangeEnum["DOLLAR_REFUND_ERROR"] = "DOLLAR_REFUND_ERROR";
})(OrderNotifyStatusChangeEnum || (OrderNotifyStatusChangeEnum = {}));
//# sourceMappingURL=OrderNotifyStatusChangeEnum.js.map